<section class="order-form-page">
  <header class="form-header">
    <a class="back-link" routerLink="/dashboard/orders">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
      <span>К заказам</span>
    </a>
    <h1>{{ pageTitle }}</h1>
  </header>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="loading-card" *ngIf="loading">Загрузка данных...</div>

  <form class="order-form" *ngIf="!loading" (ngSubmit)="saveOrder()">
    <section class="form-card">
      <h2>{{ isEditMode ? 'Данные заказа' : 'Резерв' }}</h2>

      <div class="form-grid">
        <label>
          <span>Клиент</span>
          <div class="client-picker">
            <input class="form-input" type="search" name="clientSearch" [(ngModel)]="clientSearch" placeholder="Имя, телефон, Telegram">
            <select class="form-select" name="clientId" [(ngModel)]="form.clientId" required>
              <option value="">Выберите клиента</option>
              <option *ngFor="let client of filteredClients; trackBy: trackById" [value]="client.id">{{ getClientOptionLabel(client) }}</option>
            </select>
            <small *ngIf="filteredClients.length === 0">Клиент не найден.</small>
          </div>
        </label>

        <label>
          <span>Срок резерва</span>
          <select class="form-select" name="reservationMinutes" [(ngModel)]="form.reservationMinutes">
            <option [ngValue]="30">30 минут</option>
            <option [ngValue]="60">1 час</option>
            <option [ngValue]="120">2 часа</option>
            <option [ngValue]="360">6 часов</option>
            <option [ngValue]="1440">1 день</option>
          </select>
        </label>

        <label class="full-width">
          <span>Событие</span>
          <select class="form-select" name="eventId" [(ngModel)]="form.eventId" (ngModelChange)="onEventChange()" required>
            <option value="">Выберите событие</option>
            <option *ngFor="let event of events; trackBy: trackById" [value]="event.id">{{ formatEvent(event) }} · {{ formatDate(event.startsAt) }}</option>
          </select>
        </label>
      </div>
    </section>

    <section class="form-card tickets-card" *ngIf="selectedEvent">
      <div class="card-heading">
        <div>
          <h2>{{ isEditMode ? 'Билеты в заказе' : 'Свободные билеты' }}</h2>
          <span>{{ formatEvent(selectedEvent) }}</span>
        </div>
        <strong>{{ form.ticketIds.length }} шт. · {{ formatMoney(selectedTotal) }}</strong>
      </div>

      <div class="sector-ticket-grid" *ngIf="ticketSectorGroups.length > 0; else noTickets">
        <article class="sector-ticket-card" *ngFor="let sectorGroup of ticketSectorGroups; trackBy: trackBySector">
          <header>
            <strong>Сектор {{ sectorGroup.sector }}</strong>
            <span>{{ sectorGroup.ticketsCount }} мест</span>
          </header>

          <div class="ticket-row-list">
            <section class="ticket-row-card" *ngFor="let rowGroup of sectorGroup.rows; trackBy: trackByRow">
              <div class="ticket-row-heading">
                <span>Ряд {{ rowGroup.row }}</span>
                <b>{{ rowGroup.tickets.length }} мест</b>
              </div>

              <div class="ticket-choice-list">
                <article class="ticket-choice" *ngFor="let ticket of rowGroup.tickets; trackBy: trackById" [class.selected]="isTicketSelected(ticket.id)" (click)="toggleTicket(ticket.id)">
                  <strong>Место {{ ticket.seat }}</strong>
                  <span>{{ ticket.code }}</span>
                  <label class="ticket-price-row" *ngIf="isEditMode && isTicketSelected(ticket.id); else ticketPriceView" (click)="$event.stopPropagation()">
                    <span>Цена продажи</span>
                    <input class="price-input" type="number" min="0" [name]="'ticketPrice-' + ticket.id" [(ngModel)]="priceDrafts[ticket.id]">
                  </label>
                  <ng-template #ticketPriceView>
                    <span>{{ formatMoney(getTicketPrice(ticket.id)) }}</span>
                  </ng-template>
                </article>
              </div>
            </section>
          </div>
        </article>
      </div>

      <ng-template #noTickets>
        <p class="empty-note">Свободных билетов для этого события нет.</p>
      </ng-template>
    </section>

    <section class="form-card actions-card">
      <button class="save-button" type="submit" [disabled]="!canSave">{{ saving ? 'Сохраняем...' : (isEditMode ? 'Сохранить заказ' : 'Создать резерв') }}</button>
      <a class="ghost-link" [routerLink]="isEditMode && order ? ['/dashboard/orders', order.code] : ['/dashboard/orders']">Отмена</a>
      <p class="empty-note" *ngIf="!canSave && !saving">{{ isEditMode && order?.status !== 'reserved' ? 'Редактировать можно только активный резерв.' : 'Выберите клиента, событие и хотя бы один билет.' }}</p>
    </section>
  </form>
</section>
